(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('GtpService', GtpService);

    GtpService.$inject = ['$http', 'RequestService', 'ModalConstructor', 'AlertModalService'];

    function GtpService($http, RequestService, ModalConstructor, AlertModalService) {

        var service = {
            // API Methods
            listGtp: listGtp,
            deleteGtp: deleteGtp,
            addGtp: addGtp,
            getGtp: getGtp,
            updateGtp: updateGtp,

            // Validation rules
            getRules: getRules,

            // Modal Methods
            successModalConstructor: successModalConstructor,
            errorModalConstructor: errorModalConstructor,
            confirmationModalConstructor: confirmationModalConstructor,
            addGtpModalConstructor: addGtpModalConstructor,
            editGtpModalConstructor: editGtpModalConstructor
        };

        return service;

        function deleteGtp(data) {
            return $http.delete(apiUrl(data.id)).then(responseData);
        }

        function getGtp(gtpId) {
            return $http.get(apiUrl(gtpId)).then(responseData);
        }

        function listGtp(filters, hideSpinner) {
            var expressionFilter = constructFilter(filters || {});
            return $http.get(apiUrl(), {params: expressionFilter, ignoreLoadingBar: !!hideSpinner}).then(responseData);
        }

        function addGtp(data) {
            return $http.post(apiUrl(), data).then(responseData);
        }

        function updateGtp(data) {
            return $http.put(apiUrl(), data).then(responseData);
        }

        // Validation rules
        function getRules() {
            return {
                Zhone8820G: {
                    gtpId: {min: 1, max: 2147483647},
                    defaultBw: {min: 128, max: 1048576, multiple: 64, allowZero: true},
                    guaranteedUpstreamBw: {min: 512, multiple: 512, allowZero: false},
                    dbaFixedUsCbrBw: {min: 512, max: 454208},
                    dbaAssuredUsBw: {min: 256}
                },
                Intelbras8820i: {
                    gtpId: {min: 1, max: 128},
                    defaultBw: {min: 256, max: 1240640, multiple: 64, allowZero: true},
                    dbaFixedUsCbrBw: {max: 833024},
                    dbaMaxUsBw: {allowZero: false}
                }
            };
        }

        // Helper Function
        function apiUrl(method) {
            return RequestService.apiUrl('gtps', method);
        }

        function constructFilter(filter) {
            var result = {oltId: null};
            if (filter.oltId) {
                result.oltId = filter.oltId;
            }
            return result;
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

        // Modal Methods
        function successModalConstructor(action, isMultiple) {
            return AlertModalService.success(action, isMultiple, 'gtp');
        }

        function errorModalConstructor(response, action) {
            AlertModalService.error(response, action, 'gtp');
        }

        function confirmationModalConstructor(gtpData, dataAction) {

            var confirm = {
                templateUrl: 'app/components/gtp/gtp-confirm.html',
                controller: 'GtpConfirmController',
                controllerAs: 'vmGtpConfirm',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    dataAction: function () {
                        return dataAction;
                    },
                    gtpItem: function () {
                        return gtpData;
                    }
                }
            };
            ModalConstructor.open(confirm);
        }

        function addGtpModalConstructor(scope) {
            var modal = gtpModalConfig();
            ModalConstructor.open(modal);
        }

        function editGtpModalConstructor(gtpId, scope) {
            var modal = gtpModalConfig();
            modal.scope = scope;
            modal.resolve.gtpId = gtpId;
            ModalConstructor.open(modal);
        }

        function gtpModalConfig() {
            return {
                templateUrl: 'app/components/gtp/gtp-add.html',
                controller: 'GtpAddController',
                controllerAs: 'vmGtpAdd',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    gtpId: null,
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('gtp');
                            return $translate.refresh();
                        }]
                }
            };
        }

    }
})();
